module.exports = {
  "zones": {
    "Pacific/Rarotonga": ["z", {
      "wallclock": 279676800000,
      "format": "-10/-0930",
      "abbrev": "-0930",
      "offset": -36000000,
      "posix": 279714600000,
      "save": 1800000,
      "rules": "Cook"
    }, {
      "wallclock": -2177452800000,
      "format": "-1030",
      "abbrev": "-1030",
      "offset": -37800000,
      "posix": -2177414456000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -38344000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Cook": [{
      "from": 1979,
      "to": 1991,
      "month": 2,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 1800000
    }, {
      "from": 1979,
      "to": 1990,
      "month": 9,
      "day": [0, -31],
      "time": 0,
      "clock": "wallclock",
      "save": 30,
      "letter": "",
      "saved": 0
    }, {
      "from": 1978,
      "to": 1978,
      "month": 10,
      "day": [7, 12],
      "time": 0,
      "clock": "wallclock",
      "save": 30,
      "letter": "",
      "saved": 0
    }]
  }
};